// Shared style tokens for the My Profile screen (Profile, UserDetailsCard,
// RequestedContact), matching the page shell of
// components/reviewsLeaderboard/ReviewsLeaderboardPage.jsx.
import { createTheme } from "@mui/material";

export { PRIMARY_BTN_SX, SECTION_LABEL_SX } from "../../accessManagement/styles";

export const BRAND = "#FF5200";
export const BRAND_GRADIENT = "linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)";

export const theme = createTheme({
  typography: { fontFamily: ["Quicksand", "Inter", "sans-serif"].join(","), fontSize: 16 },
});

export const PAGE_BG = {
  minHeight: "100vh",
  background: "linear-gradient(145deg, #EDF1FF 0%, #F2EEFF 38%, #FFF0ED 100%)",
  backgroundAttachment: { xs: "scroll", md: "fixed" },
};

export const CONTAINER_SX = {
  // Clears the fixed DashboardHeader (56px below 600px, 64px above) and the sidebar.
  mt: { xs: "56px", sm: "64px" },
  pt: 3,
  pb: 6,
  pl: { xs: 2, sm: 3, lg: "108px" },
  pr: { xs: 2, sm: 3 },
  "@keyframes pageFadeIn": {
    from: { opacity: 0, transform: "translateY(8px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  animation: "pageFadeIn 0.36s ease both",
};

export const CARD_SX = {
  borderRadius: 3,
  bgcolor: "#FFFFFF",
  border: "1px solid rgba(255,82,0,0.07)",
  boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
  overflow: "hidden",
};

// Soft orange square holding an icon (detail rows, empty states).
export const ICON_TILE_SX = {
  width: 36,
  height: 36,
  flexShrink: 0,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: BRAND,
  bgcolor: "rgba(255,82,0,0.08)",
};

export const MUTED = "#9CA3AF";
export const TEXT = "#1C1C2E";
export const DIVIDER = "rgba(0,0,0,0.06)";
